module.exports = __webpack_public_path__ + "img/censored.054bc2b1.png";